import { Box, Tab as MuiTab, Tabs } from "@mui/material";
import { colors } from "common/scss/themes";
import React, {
  ReactElement,
  SetStateAction,
  SyntheticEvent,
  useState
} from "react";

export interface Props {
  tabs: {
    disabled: boolean | undefined;
    label: string | ReactElement;
    index: number;
    children: ReactElement;
    isFull: boolean;
  }[];
  setCurrent?: (value: SetStateAction<number>) => void;
  widthTab?: string;
  onTabChange?: (index: number) => void;
  tabDisabled?: boolean;
  tabsFull?: boolean;
}
function Tab({
  tabs,
  setCurrent = () => {
    /*  */
  },
  widthTab = "",

  // tabDisabled = false,
  onTabChange = () => {
    /*  */
  }
}: Props) {
  const [value, setValue] = useState(0);

  const handleChange = (e: SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (setCurrent) setCurrent(newValue);
    if (onTabChange) onTabChange(newValue);
  };

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: colors.primary[8]
          }
        }}
      >
        {tabs.map((tab) => (
          <MuiTab
            key={tab.index}
            label={tab.label}
            disabled={tab.disabled}
            disableRipple
            value={tab.index}
            sx={{
              flex: tab.isFull && 1,
              "&.Mui-disabled": {
                "& .MuiTypography-root": { color: colors.gray[4] }
              },
              "&.Mui-selected": {
                color: colors.primary[8],
                borderBottom: `2px solid ${colors.primary[8]}`,
                stroke: colors.primary[8]
              }
            }}
            className={
              `font-sans text-sm font-medium text-gray-10 normal-case border-solid border-b-2 border-default-transparent stroke-gray-10 ` +
              `hover:border-primary-8 ${widthTab}`
            }
          />
        ))}
      </Tabs>

      {tabs.map(
        (tab) =>
          tab.children &&
          value === tab.index && <Box key={tab.index}>{tab.children}</Box>
      )}
    </Box>
  );
}

export default Tab;
